import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { loadMicroApp } from '@central-products/script-module-loader';
import { ErrorTypes, PromotionsBannersFlowInterface, StateTypes } from '@central-products/interface-promotions-banners-flow';
import { Environment, Jurisdiction } from './types/types';
import { trackBannerClick } from './tracking';
import { promotionsBanners } from './promotionsBanners/promotionsBanners'; // tslint:disable-next-line

var noop = function noop() {};

export var PromotionsBannersFlow = /*#__PURE__*/function (_PromotionsBannersFlo) {
  _inherits(PromotionsBannersFlow, _PromotionsBannersFlo);

  var _super = _createSuper(PromotionsBannersFlow);

  function PromotionsBannersFlow(config, dependencies) {
    var _this;

    _classCallCheck(this, PromotionsBannersFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", StateTypes.NONE);

    _defineProperty(_assertThisInitialized(_this), "bannerClicked", noop);

    _defineProperty(_assertThisInitialized(_this), "stateChanged", noop);

    if (!config.environment || _Object$values(Environment).indexOf(config.environment) === -1) {
      throw {
        error: ErrorTypes.MISSING_OR_INVALID_PARAM_ENVIRONMENT
      };
    }

    if (!config.jurisdiction || _Object$values(Jurisdiction).indexOf(config.jurisdiction) === -1) {
      throw {
        error: ErrorTypes.MISSING_OR_INVALID_PARAM_JURISDICTION
      };
    }

    if (!config.locale) {
      throw {
        error: ErrorTypes.MISSING_PARAM_LOCALE
      };
    }

    if (!config.vertical) {
      throw {
        error: ErrorTypes.MISSING_PARAM_VERTICAL
      };
    }

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(PromotionsBannersFlow, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(bannersData) {
        var _this2 = this;

        var bannerClickCallback, _this$config, locale, vertical, environment, jurisdiction, mergedBanners;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(!_Array$isArray(bannersData === null || bannersData === void 0 ? void 0 : bannersData.banners) || !(bannersData === null || bannersData === void 0 ? void 0 : bannersData.banners.length))) {
                  _context.next = 3;
                  break;
                }

                throw {
                  error: ErrorTypes.MISSING_BANNERS_DATA
                };

              case 3:
                bannerClickCallback = function bannerClickCallback(data) {
                  _this2.bannerClicked(data);

                  trackBannerClick(data);
                };

                _this$config = this.config, locale = _this$config.locale, vertical = _this$config.vertical, environment = _this$config.environment, jurisdiction = _this$config.jurisdiction;
                _context.next = 7;
                return loadMicroApp({
                  name: 'promotions-banners',
                  environment: environment,
                  jurisdiction: jurisdiction,
                  useVendors: false
                });

              case 7:
                _context.next = 9;
                return promotionsBanners({
                  bannersData: bannersData.banners,
                  graphqlClient: this.dependencies['data-access-service'],
                  locale: locale,
                  vertical: vertical
                });

              case 9:
                mergedBanners = _context.sent;

                if (mergedBanners.banners.length) {
                  window.WH.PromotionsBanners.initApplication({
                    banners: mergedBanners.banners,
                    bannerClickCallback: bannerClickCallback
                  });
                }

                this.changeState(StateTypes.STARTED);
                return _context.abrupt("return", {
                  banners: mergedBanners.bannersStatuses
                });

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  banners: []
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 15]]);
      }));

      function start(_x) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "onBannerClicked",
    value: function onBannerClicked(callback) {
      var _this3 = this;

      this.bannerClicked = callback; // unsubscribe on call

      return function () {
        _this3.bannerClicked = noop;
      };
    }
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      var _this4 = this;

      this.stateChanged = callback; // unsubscribe on call

      return function () {
        _this4.stateChanged = noop;
      };
    }
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _Promise.resolve({
                  state: this.state
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "changeState",
    value: function changeState(state) {
      if (state !== this.state) {
        this.state = state;

        if (this.stateChanged) {
          this.stateChanged({
            state: state
          });
        }
      }
    }
  }]);

  return PromotionsBannersFlow;
}(PromotionsBannersFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Qcm9tb3Rpb25zQmFubmVyc0Zsb3cudHMiXSwibmFtZXMiOlsibG9hZE1pY3JvQXBwIiwiRXJyb3JUeXBlcyIsIlByb21vdGlvbnNCYW5uZXJzRmxvd0ludGVyZmFjZSIsIlN0YXRlVHlwZXMiLCJFbnZpcm9ubWVudCIsIkp1cmlzZGljdGlvbiIsInRyYWNrQmFubmVyQ2xpY2siLCJwcm9tb3Rpb25zQmFubmVycyIsIm5vb3AiLCJQcm9tb3Rpb25zQmFubmVyc0Zsb3ciLCJjb25maWciLCJkZXBlbmRlbmNpZXMiLCJOT05FIiwiZW52aXJvbm1lbnQiLCJpbmRleE9mIiwiZXJyb3IiLCJNSVNTSU5HX09SX0lOVkFMSURfUEFSQU1fRU5WSVJPTk1FTlQiLCJqdXJpc2RpY3Rpb24iLCJNSVNTSU5HX09SX0lOVkFMSURfUEFSQU1fSlVSSVNESUNUSU9OIiwibG9jYWxlIiwiTUlTU0lOR19QQVJBTV9MT0NBTEUiLCJ2ZXJ0aWNhbCIsIk1JU1NJTkdfUEFSQU1fVkVSVElDQUwiLCJiYW5uZXJzRGF0YSIsImJhbm5lcnMiLCJsZW5ndGgiLCJNSVNTSU5HX0JBTk5FUlNfREFUQSIsImJhbm5lckNsaWNrQ2FsbGJhY2siLCJkYXRhIiwiYmFubmVyQ2xpY2tlZCIsIm5hbWUiLCJ1c2VWZW5kb3JzIiwiZ3JhcGhxbENsaWVudCIsIm1lcmdlZEJhbm5lcnMiLCJ3aW5kb3ciLCJXSCIsIlByb21vdGlvbnNCYW5uZXJzIiwiaW5pdEFwcGxpY2F0aW9uIiwiY2hhbmdlU3RhdGUiLCJTVEFSVEVEIiwiYmFubmVyc1N0YXR1c2VzIiwiY2FsbGJhY2siLCJzdGF0ZUNoYW5nZWQiLCJyZXNvbHZlIiwic3RhdGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUEsU0FBU0EsWUFBVCxRQUE2Qix3Q0FBN0I7QUFDQSxTQUNFQyxVQURGLEVBRUVDLDhCQUZGLEVBSUVDLFVBSkYsUUFPTyxxREFQUDtBQVFBLFNBQ0VDLFdBREYsRUFFRUMsWUFGRixRQUtPLGVBTFA7QUFNQSxTQUFTQyxnQkFBVCxRQUFpQyxZQUFqQztBQUNBLFNBQVNDLGlCQUFULFFBQWtDLHVDQUFsQyxDLENBQ0E7O0FBQ0EsSUFBTUMsSUFBSSxHQUFHLFNBQVBBLElBQU8sR0FBTSxDQUFFLENBQXJCOztBQUVBLFdBQWFDLHFCQUFiO0FBQUE7O0FBQUE7O0FBT0UsaUNBQVlDLE1BQVosRUFBaURDLFlBQWpELEVBQWtHO0FBQUE7O0FBQUE7O0FBQ2hHOztBQURnRzs7QUFBQTs7QUFBQSw0REFKdEVSLFVBQVUsQ0FBQ1MsSUFJMkQ7O0FBQUEsb0VBSHRDSixJQUdzQzs7QUFBQSxtRUFGOUJBLElBRThCOztBQUdoRyxRQUFJLENBQUNFLE1BQU0sQ0FBQ0csV0FBUixJQUF1QixlQUFjVCxXQUFkLEVBQTJCVSxPQUEzQixDQUFtQ0osTUFBTSxDQUFDRyxXQUExQyxNQUEyRCxDQUFDLENBQXZGLEVBQTBGO0FBQ3hGLFlBQU07QUFBRUUsUUFBQUEsS0FBSyxFQUFFZCxVQUFVLENBQUNlO0FBQXBCLE9BQU47QUFDRDs7QUFFRCxRQUFJLENBQUNOLE1BQU0sQ0FBQ08sWUFBUixJQUF3QixlQUFjWixZQUFkLEVBQTRCUyxPQUE1QixDQUFvQ0osTUFBTSxDQUFDTyxZQUEzQyxNQUE2RCxDQUFDLENBQTFGLEVBQTZGO0FBQzNGLFlBQU07QUFBRUYsUUFBQUEsS0FBSyxFQUFFZCxVQUFVLENBQUNpQjtBQUFwQixPQUFOO0FBQ0Q7O0FBRUQsUUFBSSxDQUFDUixNQUFNLENBQUNTLE1BQVosRUFBb0I7QUFDbEIsWUFBTTtBQUFFSixRQUFBQSxLQUFLLEVBQUVkLFVBQVUsQ0FBQ21CO0FBQXBCLE9BQU47QUFDRDs7QUFFRCxRQUFJLENBQUNWLE1BQU0sQ0FBQ1csUUFBWixFQUFzQjtBQUNwQixZQUFNO0FBQUVOLFFBQUFBLEtBQUssRUFBRWQsVUFBVSxDQUFDcUI7QUFBcEIsT0FBTjtBQUNEOztBQUVELFVBQUtaLE1BQUwsR0FBY0EsTUFBZDtBQUNBLFVBQUtDLFlBQUwsR0FBb0JBLFlBQXBCO0FBcEJnRztBQXFCakc7O0FBNUJIO0FBQUE7QUFBQTtBQUFBLDZGQThCcUJZLFdBOUJyQjtBQUFBOztBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQUEsc0JBZ0NVLENBQUMsZUFBY0EsV0FBZCxhQUFjQSxXQUFkLHVCQUFjQSxXQUFXLENBQUVDLE9BQTNCLENBQUQsSUFBd0MsRUFBQ0QsV0FBRCxhQUFDQSxXQUFELHVCQUFDQSxXQUFXLENBQUVDLE9BQWIsQ0FBcUJDLE1BQXRCLENBaENsRDtBQUFBO0FBQUE7QUFBQTs7QUFBQSxzQkFpQ2M7QUFBRVYsa0JBQUFBLEtBQUssRUFBRWQsVUFBVSxDQUFDeUI7QUFBcEIsaUJBakNkOztBQUFBO0FBb0NZQyxnQkFBQUEsbUJBcENaLEdBb0NrQyxTQUF0QkEsbUJBQXNCLENBQUNDLElBQUQsRUFBOEI7QUFDeEQsa0JBQUEsTUFBSSxDQUFDQyxhQUFMLENBQW1CRCxJQUFuQjs7QUFDQXRCLGtCQUFBQSxnQkFBZ0IsQ0FBQ3NCLElBQUQsQ0FBaEI7QUFDRCxpQkF2Q1A7O0FBQUEsK0JBeUM4RCxLQUFLbEIsTUF6Q25FLEVBeUNjUyxNQXpDZCxnQkF5Q2NBLE1BekNkLEVBeUNzQkUsUUF6Q3RCLGdCQXlDc0JBLFFBekN0QixFQXlDZ0NSLFdBekNoQyxnQkF5Q2dDQSxXQXpDaEMsRUF5QzZDSSxZQXpDN0MsZ0JBeUM2Q0EsWUF6QzdDO0FBQUE7QUFBQSx1QkEyQ1lqQixZQUFZLENBQUM7QUFDakI4QixrQkFBQUEsSUFBSSxFQUFFLG9CQURXO0FBRWpCakIsa0JBQUFBLFdBQVcsRUFBWEEsV0FGaUI7QUFHakJJLGtCQUFBQSxZQUFZLEVBQVpBLFlBSGlCO0FBSWpCYyxrQkFBQUEsVUFBVSxFQUFFO0FBSkssaUJBQUQsQ0EzQ3hCOztBQUFBO0FBQUE7QUFBQSx1QkFrRGtDeEIsaUJBQWlCLENBQUM7QUFDNUNnQixrQkFBQUEsV0FBVyxFQUFFQSxXQUFXLENBQUNDLE9BRG1CO0FBRTVDUSxrQkFBQUEsYUFBYSxFQUFFLEtBQUtyQixZQUFMLENBQWtCLHFCQUFsQixDQUY2QjtBQUc1Q1Esa0JBQUFBLE1BQU0sRUFBTkEsTUFINEM7QUFJNUNFLGtCQUFBQSxRQUFRLEVBQVJBO0FBSjRDLGlCQUFELENBbERuRDs7QUFBQTtBQWtEWVksZ0JBQUFBLGFBbERaOztBQXlETSxvQkFBSUEsYUFBYSxDQUFDVCxPQUFkLENBQXNCQyxNQUExQixFQUFrQztBQUNoQ1Msa0JBQUFBLE1BQU0sQ0FBQ0MsRUFBUCxDQUFVQyxpQkFBVixDQUE0QkMsZUFBNUIsQ0FBNEM7QUFDMUNiLG9CQUFBQSxPQUFPLEVBQUVTLGFBQWEsQ0FBQ1QsT0FEbUI7QUFFMUNHLG9CQUFBQSxtQkFBbUIsRUFBbkJBO0FBRjBDLG1CQUE1QztBQUlEOztBQUNELHFCQUFLVyxXQUFMLENBQWlCbkMsVUFBVSxDQUFDb0MsT0FBNUI7QUEvRE4saURBaUVhO0FBQUVmLGtCQUFBQSxPQUFPLEVBQUVTLGFBQWEsQ0FBQ087QUFBekIsaUJBakViOztBQUFBO0FBQUE7QUFBQTtBQUFBLGlEQW1FYTtBQUFFaEIsa0JBQUFBLE9BQU8sRUFBRTtBQUFYLGlCQW5FYjs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxvQ0F1RXlCaUIsUUF2RXpCLEVBdUVtRjtBQUFBOztBQUMvRSxXQUFLWixhQUFMLEdBQXFCWSxRQUFyQixDQUQrRSxDQUUvRTs7QUFDQSxhQUFPLFlBQU07QUFDWCxRQUFBLE1BQUksQ0FBQ1osYUFBTCxHQUFxQnJCLElBQXJCO0FBQ0QsT0FGRDtBQUdEO0FBN0VIO0FBQUE7QUFBQSxtQ0ErRXdCaUMsUUEvRXhCLEVBK0UyRjtBQUFBOztBQUN2RixXQUFLQyxZQUFMLEdBQW9CRCxRQUFwQixDQUR1RixDQUd2Rjs7QUFDQSxhQUFPLFlBQU07QUFDWCxRQUFBLE1BQUksQ0FBQ0MsWUFBTCxHQUFvQmxDLElBQXBCO0FBQ0QsT0FGRDtBQUdEO0FBdEZIO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxrREF5RlcsU0FBUW1DLE9BQVIsQ0FBZ0I7QUFBRUMsa0JBQUFBLEtBQUssRUFBRSxLQUFLQTtBQUFkLGlCQUFoQixDQXpGWDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxnQ0E0RnNCQSxLQTVGdEIsRUE0RnlDO0FBQ3JDLFVBQUlBLEtBQUssS0FBSyxLQUFLQSxLQUFuQixFQUEwQjtBQUN4QixhQUFLQSxLQUFMLEdBQWFBLEtBQWI7O0FBQ0EsWUFBSSxLQUFLRixZQUFULEVBQXVCO0FBQ3JCLGVBQUtBLFlBQUwsQ0FBa0I7QUFBRUUsWUFBQUEsS0FBSyxFQUFMQTtBQUFGLFdBQWxCO0FBQ0Q7QUFDRjtBQUNGO0FBbkdIOztBQUFBO0FBQUEsRUFBMkMxQyw4QkFBM0MiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBsb2FkTWljcm9BcHAgfSBmcm9tICdAY2VudHJhbC1wcm9kdWN0cy9zY3JpcHQtbW9kdWxlLWxvYWRlcic7XG5pbXBvcnQge1xuICBFcnJvclR5cGVzLFxuICBQcm9tb3Rpb25zQmFubmVyc0Zsb3dJbnRlcmZhY2UsXG4gIFByb21vdGlvbnNCYW5uZXJzRmxvd1BheWxvYWQsXG4gIFN0YXRlVHlwZXMsXG4gIFByb21vdGlvbnNCYW5uZXJzRmxvd1N0YXRlLFxuICBCYW5uZXJDbGlja1BheWxvYWQsXG59IGZyb20gJ0BjZW50cmFsLXByb2R1Y3RzL2ludGVyZmFjZS1wcm9tb3Rpb25zLWJhbm5lcnMtZmxvdyc7XG5pbXBvcnQge1xuICBFbnZpcm9ubWVudCxcbiAgSnVyaXNkaWN0aW9uLFxuICBQcm9tb3Rpb25zQmFubmVyc0Zsb3dDb25maWcsXG4gIFByb21vdGlvbnNCYW5uZXJzRmxvd0RlcGVuZGVuY2llcyxcbn0gZnJvbSAnLi90eXBlcy90eXBlcyc7XG5pbXBvcnQgeyB0cmFja0Jhbm5lckNsaWNrIH0gZnJvbSAnLi90cmFja2luZyc7XG5pbXBvcnQgeyBwcm9tb3Rpb25zQmFubmVycyB9IGZyb20gJy4vcHJvbW90aW9uc0Jhbm5lcnMvcHJvbW90aW9uc0Jhbm5lcnMnO1xuLy8gdHNsaW50OmRpc2FibGUtbmV4dC1saW5lXG5jb25zdCBub29wID0gKCkgPT4ge307XG5cbmV4cG9ydCBjbGFzcyBQcm9tb3Rpb25zQmFubmVyc0Zsb3cgZXh0ZW5kcyBQcm9tb3Rpb25zQmFubmVyc0Zsb3dJbnRlcmZhY2Uge1xuICBwcml2YXRlIHJlYWRvbmx5IGNvbmZpZzogUHJvbW90aW9uc0Jhbm5lcnNGbG93Q29uZmlnO1xuICBwcml2YXRlIHJlYWRvbmx5IGRlcGVuZGVuY2llczogUHJvbW90aW9uc0Jhbm5lcnNGbG93RGVwZW5kZW5jaWVzO1xuICBwcml2YXRlIHN0YXRlOiBTdGF0ZVR5cGVzID0gU3RhdGVUeXBlcy5OT05FO1xuICBwcml2YXRlIGJhbm5lckNsaWNrZWQ6IChkYXRhOiBCYW5uZXJDbGlja1BheWxvYWQpID0+IHZvaWQgPSBub29wO1xuICBwcml2YXRlIHN0YXRlQ2hhbmdlZDogKHN0YXRlOiBQcm9tb3Rpb25zQmFubmVyc0Zsb3dTdGF0ZSkgPT4gdm9pZCA9IG5vb3A7XG5cbiAgY29uc3RydWN0b3IoY29uZmlnOiBQcm9tb3Rpb25zQmFubmVyc0Zsb3dDb25maWcsIGRlcGVuZGVuY2llczogUHJvbW90aW9uc0Jhbm5lcnNGbG93RGVwZW5kZW5jaWVzKSB7XG4gICAgc3VwZXIoKTtcblxuICAgIGlmICghY29uZmlnLmVudmlyb25tZW50IHx8IE9iamVjdC52YWx1ZXMoRW52aXJvbm1lbnQpLmluZGV4T2YoY29uZmlnLmVudmlyb25tZW50KSA9PT0gLTEpIHtcbiAgICAgIHRocm93IHsgZXJyb3I6IEVycm9yVHlwZXMuTUlTU0lOR19PUl9JTlZBTElEX1BBUkFNX0VOVklST05NRU5UIH07XG4gICAgfVxuXG4gICAgaWYgKCFjb25maWcuanVyaXNkaWN0aW9uIHx8IE9iamVjdC52YWx1ZXMoSnVyaXNkaWN0aW9uKS5pbmRleE9mKGNvbmZpZy5qdXJpc2RpY3Rpb24pID09PSAtMSkge1xuICAgICAgdGhyb3cgeyBlcnJvcjogRXJyb3JUeXBlcy5NSVNTSU5HX09SX0lOVkFMSURfUEFSQU1fSlVSSVNESUNUSU9OIH07XG4gICAgfVxuXG4gICAgaWYgKCFjb25maWcubG9jYWxlKSB7XG4gICAgICB0aHJvdyB7IGVycm9yOiBFcnJvclR5cGVzLk1JU1NJTkdfUEFSQU1fTE9DQUxFIH07XG4gICAgfVxuXG4gICAgaWYgKCFjb25maWcudmVydGljYWwpIHtcbiAgICAgIHRocm93IHsgZXJyb3I6IEVycm9yVHlwZXMuTUlTU0lOR19QQVJBTV9WRVJUSUNBTCB9O1xuICAgIH1cblxuICAgIHRoaXMuY29uZmlnID0gY29uZmlnO1xuICAgIHRoaXMuZGVwZW5kZW5jaWVzID0gZGVwZW5kZW5jaWVzO1xuICB9XG5cbiAgcHVibGljIGFzeW5jIHN0YXJ0KGJhbm5lcnNEYXRhOiBQcm9tb3Rpb25zQmFubmVyc0Zsb3dQYXlsb2FkKSB7XG4gICAgdHJ5IHtcbiAgICAgIGlmICghQXJyYXkuaXNBcnJheShiYW5uZXJzRGF0YT8uYmFubmVycykgfHwgIWJhbm5lcnNEYXRhPy5iYW5uZXJzLmxlbmd0aCkge1xuICAgICAgICB0aHJvdyB7IGVycm9yOiBFcnJvclR5cGVzLk1JU1NJTkdfQkFOTkVSU19EQVRBIH07XG4gICAgICB9XG5cbiAgICAgIGNvbnN0IGJhbm5lckNsaWNrQ2FsbGJhY2sgPSAoZGF0YTogQmFubmVyQ2xpY2tQYXlsb2FkKSA9PiB7XG4gICAgICAgIHRoaXMuYmFubmVyQ2xpY2tlZChkYXRhKTtcbiAgICAgICAgdHJhY2tCYW5uZXJDbGljayhkYXRhKTtcbiAgICAgIH07XG5cbiAgICAgIGNvbnN0IHsgbG9jYWxlLCB2ZXJ0aWNhbCwgZW52aXJvbm1lbnQsIGp1cmlzZGljdGlvbiB9ID0gdGhpcy5jb25maWc7XG5cbiAgICAgIGF3YWl0IGxvYWRNaWNyb0FwcCh7XG4gICAgICAgIG5hbWU6ICdwcm9tb3Rpb25zLWJhbm5lcnMnLFxuICAgICAgICBlbnZpcm9ubWVudCxcbiAgICAgICAganVyaXNkaWN0aW9uLFxuICAgICAgICB1c2VWZW5kb3JzOiBmYWxzZSxcbiAgICAgIH0pO1xuXG4gICAgICBjb25zdCBtZXJnZWRCYW5uZXJzID0gYXdhaXQgcHJvbW90aW9uc0Jhbm5lcnMoe1xuICAgICAgICBiYW5uZXJzRGF0YTogYmFubmVyc0RhdGEuYmFubmVycyxcbiAgICAgICAgZ3JhcGhxbENsaWVudDogdGhpcy5kZXBlbmRlbmNpZXNbJ2RhdGEtYWNjZXNzLXNlcnZpY2UnXSxcbiAgICAgICAgbG9jYWxlLFxuICAgICAgICB2ZXJ0aWNhbCxcbiAgICAgIH0pO1xuXG4gICAgICBpZiAobWVyZ2VkQmFubmVycy5iYW5uZXJzLmxlbmd0aCkge1xuICAgICAgICB3aW5kb3cuV0guUHJvbW90aW9uc0Jhbm5lcnMuaW5pdEFwcGxpY2F0aW9uKHtcbiAgICAgICAgICBiYW5uZXJzOiBtZXJnZWRCYW5uZXJzLmJhbm5lcnMsXG4gICAgICAgICAgYmFubmVyQ2xpY2tDYWxsYmFjayxcbiAgICAgICAgfSk7XG4gICAgICB9XG4gICAgICB0aGlzLmNoYW5nZVN0YXRlKFN0YXRlVHlwZXMuU1RBUlRFRCk7XG5cbiAgICAgIHJldHVybiB7IGJhbm5lcnM6IG1lcmdlZEJhbm5lcnMuYmFubmVyc1N0YXR1c2VzIH07XG4gICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgIHJldHVybiB7IGJhbm5lcnM6IFtdIH07XG4gICAgfVxuICB9XG5cbiAgcHVibGljIG9uQmFubmVyQ2xpY2tlZChjYWxsYmFjazogKGRhdGE6IEJhbm5lckNsaWNrUGF5bG9hZCkgPT4gdm9pZCk6ICgpID0+IHZvaWQge1xuICAgIHRoaXMuYmFubmVyQ2xpY2tlZCA9IGNhbGxiYWNrO1xuICAgIC8vIHVuc3Vic2NyaWJlIG9uIGNhbGxcbiAgICByZXR1cm4gKCkgPT4ge1xuICAgICAgdGhpcy5iYW5uZXJDbGlja2VkID0gbm9vcDtcbiAgICB9O1xuICB9XG5cbiAgcHVibGljIG9uU3RhdGVDaGFuZ2VkKGNhbGxiYWNrOiAoc3RhdGU6IFByb21vdGlvbnNCYW5uZXJzRmxvd1N0YXRlKSA9PiB2b2lkKTogKCkgPT4gdm9pZCB7XG4gICAgdGhpcy5zdGF0ZUNoYW5nZWQgPSBjYWxsYmFjaztcblxuICAgIC8vIHVuc3Vic2NyaWJlIG9uIGNhbGxcbiAgICByZXR1cm4gKCkgPT4ge1xuICAgICAgdGhpcy5zdGF0ZUNoYW5nZWQgPSBub29wO1xuICAgIH07XG4gIH1cblxuICBwdWJsaWMgYXN5bmMgZ2V0U3RhdGUoKSB7XG4gICAgcmV0dXJuIFByb21pc2UucmVzb2x2ZSh7IHN0YXRlOiB0aGlzLnN0YXRlIH0pO1xuICB9XG5cbiAgcHJpdmF0ZSBjaGFuZ2VTdGF0ZShzdGF0ZTogU3RhdGVUeXBlcykge1xuICAgIGlmIChzdGF0ZSAhPT0gdGhpcy5zdGF0ZSkge1xuICAgICAgdGhpcy5zdGF0ZSA9IHN0YXRlO1xuICAgICAgaWYgKHRoaXMuc3RhdGVDaGFuZ2VkKSB7XG4gICAgICAgIHRoaXMuc3RhdGVDaGFuZ2VkKHsgc3RhdGUgfSk7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4iXX0=